import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../components/Icon/Icon.styles';

/** @mixin iconSizeMixin */
/**
 * Gives icon children an explicit size.
 *
 * @example
 * import { iconSizeMixin, IconHeart } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${iconSizeMixin}
 * `;
 *
 * <Component iconSize="sm">A small icon: <IconHeart /></Component>
 *
 * @method
 * @param props {object}
 * @param props.iconSize {string|number} The icon size.
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
export var iconSizeMixin = function iconSizeMixin(props) {
  var iconSize = props.iconSize;
  return token('icons.sizes', function (iconSizes) {
    if (!iconSizes) {
      return '';
    }
    var size = iconSizes[iconSize] || iconSize;
    return css(["> ", "{display:block;height:", "px;width:", "px;}"], StyledIcon, size, size);
  })(props);
};